import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL || ""}/service-worker.js`, {
      updateViaCache: "none"
    })
    .then((registration) => {
      const postPrewarmMessage = () => {
        const worker =
          registration.active || registration.waiting || registration.installing;
        worker?.postMessage({ type: "PREWARM_ASSETS" });
      };

      postPrewarmMessage();
      registration.update().catch(() => {});
      navigator.serviceWorker.ready.then(postPrewarmMessage).catch(() => {});
      navigator.serviceWorker.addEventListener("controllerchange", postPrewarmMessage);
    })
    .catch((error) => {
      console.error("Service worker registration failed:", error);
    });
}
